/* IMPORTANT: Before modifying this file, please update CHANGELOG.md with a summary of your changes.
Also, make clear comments about every change in this file and what it was replacing so that we don't end up trying the same fixes repeatedly. */

import React, { useState } from 'react';
import Form from './components/Form';
import Loading from './components/Loading';
import Results from './components/Results';
import { generateIntegrationPrompt } from './services/api';
import './App.css';

interface FormData {
  apiName: string;
  useCase: string;
  name: string;
  email: string;
  acceptTerms: boolean;
}

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [markdownResult, setMarkdownResult] = useState<string | null>(null);

  const handleSubmit = async (data: FormData) => {
    setIsLoading(true);
    try {
      const response = await generateIntegrationPrompt({
        apiName: data.apiName,
        useCase: data.useCase,
        name: data.name,
        email: data.email
      });
      setMarkdownResult(response.markdown);
    } catch (error) {
      console.error('Error generating integration prompt:', error);
      alert('An error occurred while generating the integration prompt. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-4">API Integration Accelerator</h1>
          <p className="text-xl text-gray-600">
            Generate comprehensive integration instructions for any API in seconds
          </p>
        </div>

        <Form onSubmit={handleSubmit} isLoading={isLoading} />
        
        <Loading isVisible={isLoading} />
        
        <Results markdown={markdownResult} isVisible={!isLoading && markdownResult !== null} />
      </div>
    </div>
  );
}

export default App;
